<div *ngIf="document" class="document-window">
  <div class="empty-row" style="height: 70px"></div>
  <div class="upper-row" @slideDown>
    <div class="file-name">
      <span>{{document.name}}</span>
    </div>
    <div class="divider"></div>
    <div class="page-selector">
      <a (click)="goDown()">
        <img src="./assets/ui/svg/grey/arrow-down-circle.svg"/>
      </a>
      <a (click)="goUp()">
        <img src="./assets/ui/svg/grey/arrow-up-circle.svg"/>
      </a>
      <app-page-indicator [currentPage]="currentPage" [maxPage]="document.numberOfPages"></app-page-indicator>
    </div>
    <div class="divider"></div>
    <app-magnifying-glass (selectedVal)="changeScale($event)"></app-magnifying-glass>

    <div class="filler"></div>
    <div class="close" (click)="goBack()">
      <img src="./assets/ui/svg/grey/Clode-Window-x-icon.svg"/>
    </div>
  </div>

  <div class="document-view">
    <div class="main-document-container" [style.height.px]="documentHeight">
      <div class="main-document" @fadeIn>
        <app-inner-html [inputData]="htmlWithMarks" (deleteEntity)="deleteEntity($event)"
                        (selectedText)="showSelectedText($event)" [scale]="documentScale"
                        [documentHeight]="documentHeight" (pageChange)="currentPage=$event"
                        [currentPage]="currentPage"></app-inner-html>
      </div>

    </div>
    <div class="main-document-sidenav" @slideRight>
      <app-entities-bar [entities]="entities" (deleteEntity)="deleteEntity($event)"
                        [hasEntityChange]="entitieChange" (updateEntity)="updateEntities()"
                        [labels]="document.labels" (downloadDocument)="downloadDocument()"></app-entities-bar>
    </div>
  </div>
</div>

<button mat-icon-button [matMenuTriggerFor]="labelMenu" id="menuBtn"></button>
<mat-menu #labelMenu="matMenu" (close)="onMenuClosed()">
  <button mat-menu-item *ngFor="let label of document.labels" (click)="makeSelection(label.display_name)">{{label.display_name | titlecase}}</button>
</mat-menu>
